import GenericService from './genericService';
import axiosInstance from '../utils/axios';

class userService extends GenericService {
  constructor() {
    super('/users', axiosInstance);
  }
}

export default new userService(); 